export const DEFAULT_BRAND_LOGO = "/img/pv_logo.png";
export const DEFAULT_IMAGE_FALLBACK = "/img/pv_logo.png";
